import PaginationBoxView from '@components/ui/pagination/PaginationBoxView'

export default PaginationBoxView
